import { Checkbox } from 'antd'
import type { CheckboxProps } from 'antd'
import type { CheckboxGroupProps } from 'antd/es/checkbox'
import type React from 'react'

export type CheckboxCustomProps = (CheckboxProps | CheckboxGroupProps) & {
  group?: boolean
  button?: boolean
}

const getCheckboxType = ({ group, button }: { group?: boolean; button?: boolean }) => {
  if (group) return Checkbox.Group
  // Note: antd Checkbox doesn't natively have Checkbox.Button, but keeping logic
  if (button) return (Checkbox as unknown as Record<string, React.ElementType>).Button || Checkbox
  return Checkbox
}

const CheckboxCustom = (props: CheckboxCustomProps) => {
  const { group = false, button = false, ...rest } = props
  const ElementCheckbox = getCheckboxType({ group, button })
  return <ElementCheckbox {...rest} />
}

export default CheckboxCustom
